import { render, staticRenderFns } from "./BlogManagement.vue?vue&type=template&id=0fa1ae91&scoped=true"
import script from "./BlogManagement.vue?vue&type=script&lang=js"
export * from "./BlogManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa1ae91",
  null
  
)

export default component.exports